import { trans } from "@/service/i18n/i18n";
import { PictureUpload } from "@/components/common/picture-upload/picture-upload";
import { getDaysToDateInFutureVerbose } from "@/service/date/day";
import { BuyButton } from "@/components/ecommerce/buy-button";
import { XIcon } from "lucide-react";

export const RenewModal = ({
  renew,
  image,
  title,
  setIsOpen,
}: {
  renew: RenewVM;
  image: ImageVM;
  title: string;
  setIsOpen: (value: boolean) => void;
}) => {
  return (
    <div className="p-6">
      <h3 className="my-2 text-center text-lg font-semibold">
        {trans("education.course.renew.full_title")}
      </h3>
      <div className="my-6 mt-2 flex w-full flex-col items-center justify-between gap-3 rounded-lg border border-[#EDEEF2] px-[18px] py-[14px] lg:my-8 lg:mt-8 lg:max-h-[112px] lg:flex-row">
        <div className="">
          <PictureUpload image={image} maxHeight={100} className="rounded-md" />
        </div>
        <div className="text-center text-sm lg:text-left">{title}</div>
        <div className="shrink-0 rounded-lg border p-2 text-sm font-semibold">
          {getDaysToDateInFutureVerbose(new Date(renew.expiredAt))}
        </div>
      </div>

      <p className="text-muted-foreground text-center text-sm">
        {trans("education.course.renew.desc")}
      </p>

      <div className="text-cold-grey-100 mt-8 mb-4 text-center text-sm">
        {trans("education.course.renew_by")}
      </div>

      <div className="flex flex-col items-center justify-center gap-5 md:flex-row">
        {renew.items.map((item) => (
          <BuyButton
            key={item.name}
            product={item.product}
            instantMoveToCart
            text={item.name}
            category="Kurs"
            name={item.name}
            variant={"blue"}
          />
        ))}
      </div>

      <XIcon
        className="absolute top-4 right-4 h-4 w-4 cursor-pointer"
        onClick={() => setIsOpen(false)}
      />
    </div>
  );
};
